import React, { useEffect, useState } from "react";
import "./Popup.css";

function Popup({ message, type = "success", onClose, autoClose = true, duration = 3000 }) {
    const [isExiting, setIsExiting] = useState(false);

    // Handle both auto-close and manual close with exit animation
    const handleClose = () => {
        setIsExiting(true);
        setTimeout(() => {
            onClose();
        }, 300); // Match animation duration
    };

    // Auto close effect with animation
    useEffect(() => {
        if (message && autoClose) {
            const timer = setTimeout(() => {
                handleClose();
            }, duration);

            return () => clearTimeout(timer);
        }
    }, [autoClose, duration, message]);

    // Return null after all hooks are called
    if (!message) return null;

    // Determine the appropriate icon and color based on type
    const getTypeInfo = () => {
        switch (type) {
            case "success":
                return { icon: "✓", color: "#28a745" };
            case "error":
                return { icon: "✗", color: "#dc3545" };
            case "warning":
                return { icon: "!", color: "#ffc107" };
            case "info":
                return { icon: "i", color: "#17a2b8" };
            default:
                return { icon: "✓", color: "#28a745" };
        }
    };

    const typeInfo = getTypeInfo();

    return (
        <div className={`wt-popup-overlay wt-popup-${type} ${isExiting ? 'wt-popup-exit' : ''}`}>
            <div className="wt-popup-box">
                <div className="wt-popup-content">
                    <span className="wt-popup-icon" style={{ color: typeInfo.color }}>
                        {typeInfo.icon}
                    </span>
                    <p>{message}</p>
                </div>
                <button className="wt-popup-close" onClick={handleClose}>
                    ×
                </button>
            </div>
        </div>
    );
}

export default Popup;